import mitt, { Emitter } from 'mitt'

type Events = {
  deviceUpgrade: any; // 장치 업그레이드
  deviceLogUploadProgress: any // 장치 로그 업로드
  flightTaskWs: any // 이착륙장 미션 메시지
  droneControlWs: any // 비행 명령 정보
  droneControlMqttInfo: any // DRC 링크 알림
  flightAreasDroneLocationWs: any
  flightAreasSyncProgressWs: any
  flightAreasUpdateWs: any
};

const emitter: Emitter<Events> = mitt<Events>()

export default emitter
